import ConvertProposalRequestAction from './ConvertProposalRequestAction';
const meta = {
    title: 'Features/Proposals/ConvertProposalRequestAction',
    component: ConvertProposalRequestAction,
    args: {
        proposalId: 1
    }
};
export default meta;
export const LabelledButton = {};
export const IconInChip = {
    args: { iconOnly: true, inspectionId: 42 }
};
